<template>
    <el-drawer title="子商品新增/修改" :visible.sync="drawerShow" :wrapperClosable="false" :destroy-on-close="true" size="auto"
        @close="close" append-to-body>
        <div class="drawer-content" v-loading="dataLoading">
            <el-form :model="formData" :rules="rules" ref="formData" label-position="top" size="medium">
                <el-form-item prop="cover" label="商品封面（视频封面）：">
                    <ImageUpload :url.sync="formData.cover" :urlFull.sync="coverUrl"></ImageUpload>
                </el-form-item>
                <el-form-item prop="name" label="商品名称：">
                    <el-input v-model="formData.name" :maxlength="20" show-word-limit></el-input>
                </el-form-item>
                <el-form-item prop="bannerList" label="Banner元素：">
                    <div class="color-danger">请移步至“运营管理-H5页面配置”管理你的Banner元素</div>
                    <!-- <banner-form ref="bannerForm" :s-list.sync="formData.bannerList" v-if="reFresh"></banner-form> -->
                </el-form-item>
                <el-form-item prop="detail" label="商品详情：">
                    <tinymce v-model="formData.detail" :height="400" :toolbar="toolbar" :menubar="false" v-if="reFresh">
                    </tinymce>
                </el-form-item>
            </el-form>
        </div>
        <div class="drawer-footer">
            <el-button @click="close">取消</el-button>
            <el-button type="primary" @click="submitForm()" :loading="btnLoading">确认</el-button>
        </div>
    </el-drawer>
</template>
<script>
import ImageUpload from "@/components/ImageUpload";
import BannerForm from "./BannerForm";
import Tinymce from '@/components/Tinymce';
const defaultData = {
    bannerList: [],
    cover: "",
    detail: "",
    id: "",
    name: "",
    status: 1,
}
export default {
    props: {
        subscribeId: {
            type: [Number, String],
            default: 1,
        }
    },
    components: {
        ImageUpload, BannerForm, Tinymce
    },
    data() {
        return {
            drawerShow: false,
            btnLoading: false,
            dataLoading: false,
            formData: {
                ...defaultData
            },
            rules: {
                name: [{ required: true, message: "请填写商品名称" }],
                cover: [{ required: true, message: "请上传商品封面" }],
            },
            toolbar: ['formatselect fontsizeselect | forecolor bold strikethrough | alignleft aligncenter alignright alignjustify | image media'],
            coverUrl: "",
            reFresh: false,
        }
    },
    methods: {
        close() {
            this.$nextTick(() => {
                this.$refs.formData && this.$refs.formData.resetFields();
                this.drawerShow = false;
                this.reFresh = false;
                this.coverUrl = "";
                this.formData = {
                    ...defaultData,
                    bannerList: []
                }
            });
        },
        show(id) {
            if (id) {
                this.formData.id = id;
                this.getData();
            } else {
                this.reFresh = true;
            }
            this.drawerShow = true;
        },
        getData() {
            this.dataLoading = true;
            this.$request({
                url: '/subscribe/sub/detail',
                params: { id: this.formData.id },
                method: "post",
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state && result) {
                        this.formData = {
                            ...this.formData,
                            ...result
                        }
                        this.coverUrl = result.cover;
                        this.reFresh = true;
                    } else {
                        this.$message.error(msg || "获取数据失败,请重试");
                    }
                })
                .catch(() => {
                    self.$message.error("获取数据失败,请重试");
                })
                .finally(() => {
                    this.dataLoading = false;
                });
        },
        submitForm() {
            this.$refs["formData"].validate((valid) => {
                if (valid) {
                    if (this.$refs.bannerForm && this.$refs.bannerForm.getWList().length > 0) {
                        this.$confirm('存在上传中或待上传的文件，提交后将无法保存这些文件，确认提交吗？', '提交', {
                            confirmButtonText: '确认提交',
                            cancelButtonText: '稍后提交',
                            showClose: false,
                            closeOnClickModal: false,
                            closeOnPressEscape: false,
                            center: true
                        }).then(() => {
                            this.submitAction();
                        }).catch(() => {

                        });
                    } else {
                        this.submitAction();
                    }
                } else {
                    return false;
                }
            });
        },
        submitAction() {
            this.btnLoading = true;
            this.$request({
                url: '/subscribe/sub/save',
                data: {
                    ...this.formData,
                    subscribeId: this.subscribeId
                },
                method: "post",
            })
                .then((res) => {
                    const { state, msg } = res.data;
                    if (state == 1) {
                        this.$emit('onUpdate');
                        this.close();
                    } else {
                        this.$message.error(msg || "操作失败,请重试");
                    }
                })
                .catch(() => {
                    self.$message.error("操作失败,请重试");
                })
                .finally(() => {
                    this.btnLoading = false;
                });
        }
    }
}
</script>

<style lang="scss" scoped>

</style>